module.exports = function() {
  return new Worker(__webpack_public_path__ + "0c28ceed89975a4008c4.worker.js");
};